import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { SVG_COMPONENTS } from '@/assets/admin';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

const ThumbUpIcon = SVG_COMPONENTS.THUMB_UP;

interface MaintenanceEmptyStateProps {
  title?: string;
  subtitle?: string;
}

export const MaintenanceEmptyState: React.FC<MaintenanceEmptyStateProps> = React.memo(({
  title = 'No service requests',
  subtitle = 'You have no open service requests at the moment',
}) => {
  const { colors } = useThemeColors();

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <ThumbUpIcon width={68} height={68} color={colors.text.dimmer} />
      </View>
      <View style={styles.textContainer}>
        <Text style={[styles.title, { color: colors.text.primary }]}>{title}</Text>
        <Text style={[styles.message, { color: colors.text.muted }]}>{subtitle}</Text>
      </View>
    </View>
  );
});

MaintenanceEmptyState.displayName = 'MaintenanceEmptyState';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 40,
    paddingVertical: 65,
    gap: 18,
  },
  iconContainer: {
    width: 68,
    height: 68,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    alignItems: 'center',
    gap: 6,
    width: 240,
  },
  title: {
    ...REDESIGN_TYPOGRAPHY.cardTitleLarge,
    lineHeight: 24,
    textAlign: 'center',
  },
  message: {
    ...REDESIGN_TYPOGRAPHY.body,
    lineHeight: 21,
    textAlign: 'center',
  },
});
